import './style.css'
import ReactDOM from 'react-dom/client'
import Application from './Application.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(<Application />)